// 粒度类型
export enum GranularityType {
  // 天
  day = 0,
  // 小时
  hour = 1,
}

// 服务商类型
export enum AgencyType {
  // 服务商账号
  parent = 'parent',
  // 服务商子账号
  child = 'child',
}

// 图表颜色
export const CHART_COLOR = [
  '#296BEF',
  '#9AD6FF',
  '#FFAE19',
  '#76C84D',
  '#8E84FD',
  '#FF6D5E',
  '#5E94FF',
  '#BBE4FF',
  '#FFCC41',
  '#96D960',
  '#BCA1FF',
  '#FF9C92',
];
